import { render, staticRenderFns } from "./ReMenDiscoverDetail.vue?vue&type=template&id=3ac43128&scoped=true"
import script from "./ReMenDiscoverDetail.vue?vue&type=script&lang=js"
export * from "./ReMenDiscoverDetail.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ReMenDiscoverDetail.vue?vue&type=style&index=1&id=3ac43128&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac43128",
  null
  
)

export default component.exports